import React, { useState } from 'react';
import './App.css';
import Game from './Game';
import StudyGuide from './StudyGuide';

function App() {
  const [playGame, setPlayGame] = useState(true);

  if (playGame) {
    // eslint-disable-next-line no-undef
    mixpanel.track("Game start");
  }

  return (
    <div className="App">
      <header className="App-header">
        <h1>Let's Meet the Olores!</h1>
      </header>

      {playGame &&
        <div>
          <Game></Game>
          <div style={{ marginTop: '30px' }}>
            <button style={{ fontSize: '20px' }} onClick={() => { setPlayGame(false); }}>Study Guide</button>
          </div>
        </div>
      }
      {!playGame &&
        <div style={{ marginTop: "20px" }}>
          <button onClick={() => { setPlayGame(true); }}>Back to Game</button>
          <h2>But first, let's study!</h2>
          <StudyGuide></StudyGuide>
        </div>
      }
    </div>
  );
}

export default App;
